export default {
  name: 'SortTab',
  props: {
    tabConfig: Array
  },
  methods: {
    tabItemClickHandler(e) {
      let curTabIndex = e.currentTarget.dataset.index;
      this.$emit('click-sort-tab', { curTabIndex });
    }
  }
};
